"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledPx2rem = _interopRequireDefault(require("../../utils/styled-px2rem"));

var _Button = _interopRequireDefault(require("../Button"));

var _templateObject, _templateObject2;

var _excluded = ["autoFocus", "children", "functional"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Tab = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Tab, _React$PureComponent);

  var _super = _createSuper(Tab);

  function Tab() {
    (0, _classCallCheck2["default"])(this, Tab);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Tab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          children = _this$props.children,
          isFunctional = _this$props.functional,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var tab = isFunctional ? /*#__PURE__*/_react["default"].createElement("li", null) : /*#__PURE__*/_react["default"].createElement(StyledTab, null);

      var content = /*#__PURE__*/_react["default"].createElement(StyledButton, {
        autoFocus: autoFocus,
        functional: true
      }, children);

      return /*#__PURE__*/_react["default"].cloneElement(tab, props, content);
    }
  }]);
  return Tab;
}(_react["default"].PureComponent);

Tab.propTypes = {
  autoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  functional: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  selected: _propTypes["default"].bool,
  value: _propTypes["default"].string.isRequired
};
Tab.defaultProps = {
  autoFocus: false,
  children: '',
  className: '',
  disabled: false,
  functional: false,
  onClick: Function.prototype,
  selected: false
};

var StyledTab = _styledPx2rem["default"].li(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: #e6e6e6;\n  border: 1px solid #919499;\n  border-radius: 4px;\n  box-sizing: content-box;\n  \n  ", "\n\n  ", "\n"])), function (props) {
  return props.selected && "\n    background-color: #fff;\n    border-color: transparent;\n  ";
}, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: .4;\n  ";
});

var StyledButton = (0, _styledPx2rem["default"])(_Button["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: inherit;\n  height: 100%;\n  width: 100%;\n  \n  > * {\n    border-radius: inherit;\n  }\n"])));
var _default = Tab;
exports["default"] = _default;